import styled from '@emotion/styled'

export const TermsContentWrapper = styled.div``
